export default __webpack_public_path__ + "static/media/SteadyTransientImg.1592aa68.jpg";